module.exports = __webpack_public_path__ + "static/media/undraw_web_shopping_dd4l.04b6ce0b.svg";